import { Auth } from '@/services/auth-service'
import { computedOf, effectOf, TNode, When } from '@tempots/dom'
import { NavigationService } from '@tempots/ui'

export interface RequireAuthProps {
  /** Optional custom loading message */
  loading?: TNode
  /** Optional redirect path (defaults to '/signin') */
  redirectTo?: string
}

/**
 * A component that wraps other components and ensures the user is authenticated.
 * If the user is not signed in, they will be redirected to the sign-in page.
 * While checking authentication status (authReady=false), a loading indicator is displayed.
 */
export function RequireAuth(
  { loading, redirectTo = '/signin' }: RequireAuthProps,
  render: () => TNode
) {
  const canRender = computedOf(
    Auth.authReady,
    Auth.isSignedIn
  )((ready, signedIn) => ready && signedIn)

  effectOf(
    Auth.authReady,
    Auth.isSignedIn
  )((ready, signedIn) => {
    if (ready && !signedIn) {
      NavigationService.navigate(redirectTo, { replace: true })
    }
  })

  return When(canRender, render, () => loading)
}
